 import ApiService from "@/core/services/api.service";
 import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async getNotasFiscais(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.post("notasFiscais/access/listar", dados);
        return data;
    },
    async postNotaFiscal(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce("notasFiscais/access/salvar", dados);
        return data;
    },
    async deleteNotaFiscal(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce("notasFiscais/access/excluir", {ID_NOTA_FISCAL:dados.id, componente:dados.componente});
        return data;
    },
    async getNotaFiscalProdutos(context, dados){
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.post("notasFiscais/access/listaNotaFiscalProdutos", dados);
        return data;
    },
    async geraNotaFiscal(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.post("notasFiscais/access/emitirNotaFiscal", {ID_NOTA_FISCAL:dados.ID_NOTA_FISCAL});
        return data;
    },
    async listarNotaFiscal(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.post("notasFiscais/access/listarNotaFiscalEmitida", {ID_NOTA_FISCAL:dados.ID_NOTA_FISCAL});
        return data;
    },
    async cancelarNotaFiscal(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.post("notasFiscais/access/cancelarNotaFiscalEmitida", {ID_NOTA_FISCAL:dados.ID_NOTA_FISCAL});
        return data;
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};    
